import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../../context/store";
import { functions } from "../../constants/common-functions";
import { colorFunctions } from "../../constants/colors";
import { useHistory } from "react-router-dom";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { STRINGIFY } from "../../constants/general-constants";
import background from "../../../images/background.jpg";
import useInsights from "./hooks/useInsights";
import InsightsDrawer
from "./components/InsightsDrawer";

import InsightKpiStrip
from "./components/InsightKpiStrip";

import InsightsByCategory
from "./components/InsightsByCategory";

import InsightsOverTime
from "./components/InsightsOverTime";

import PortfolioRiskMatrix
from "./components/PortfolioRiskMatrix";

import ComplianceOverview
from "./components/ComplianceOverview";

import QualitativeImpact
from "./components/QualitativeImpact";

import CostImpactAnalysis
from "./components/CostImpactAnalysis";

import RecommendationsPipeline
from "./components/RecommendationsPipeline";

import PortfolioInspector
from "./components/inspector/PortfolioInspector";


import WorkspaceDrawer
from "./components/inspector/WorkspaceDrawer";

import ExecutiveSummaryCard
from "../../components/dashboardlayouts/ExecutiveSummaryCard";



import {SYSTEM_ROLE_SUPERADMIN} from "../../constants/general-constants";
import {SYSTEM_ROLE_ADMIN} from "../../constants/general-constants";
import {SYSTEM_ROLE_CONTENT_CREATOR} from "../../constants/general-constants";
import {DEFAULT_BLUE_GRADIENT} from "../../constants/styles";

import {
  OMNISCAN_CORPORATE_RED,
  OMNISCAN_CORPORATE_GREEN,
  OMNISCAN_CORPORATE_PURPLE,
  OMNISCAN_BLUE
} from "../../constants/colors";


import
{
    NON_HERO_BACKGROUND,
    DASHBOARD_TABLE_STYLE,
    DASHBOARD_ROW_STYLE,
    DASHBOARD_COLUMN_STYLE
}
from "../../constants/styles";

export default function Insights() {
	
	
	const [workspaceVisible, setWorkspaceVisible] =
	useState(false);
	
	const [workspaceRequest, setWorkspaceRequest] =
	useState(null);
	
	const [showInsightDrawer, setShowInsightDrawer] =
	    useState(false);

	const [selectedInsightCategory, setSelectedInsightCategory] =
	    useState(null);

  const globalState = useContext(store);
  const history = useHistory();
  const searchId = useRef(null);
 
  const handleChange = function (e) {
    
   };
   
   
   const handleWorkspaceRequested = () => {
		setWorkspaceVisible(true);
   }
   
   const hideWorkspaceDrawer = () => {
   	setWorkspaceVisible(false);
     }
	 
	 
	 //--------------------------------------------------------
	 // Overlay
	 //--------------------------------------------------------

	 const overlayStyle =
	 {
	     position: "fixed",

	     top: 0,
	     left: 0,

	     width: "100%",
	     height: "100%",

	     background:
	         "rgba(255,255,255,0.45)",

	     pointerEvents: "none",

	     opacity: 0,

	     animation:
	         "fadeOverlay 4s ease forwards"
	 };

  // ---------------- STYLES ----------------

  const thisContainer = {
   	display:"flex",
   	position:"fixed",
   	flexDirection:"column",
   	right:"0px",
   	bottom:"0px",
   	left:"20px",
   	top:"0px",
	  zIndex:"1",
	  padding:'20px'
   };

   const contentStyle =
   	{
   	    flex: 1,

   	    display: "flex",

   	    height: "calc(100% - 20px)",

   	    padding: "8px 0px 8px 0px",

   	    justifyContent: "space-around",

   	    alignItems: "center"
   	};
	
	
	const {
	    insightsByCategory,
	    insightList,
	    loading,
	    insightListLoading,
	    loadInsightListForCategory
	} = useInsights();
	
	const getInsightListForCategory = (category) => {
		setSelectedInsightCategory(
		       category.category
		   );

		   loadInsightListForCategory(
		       category.category
		   );

		   setShowInsightDrawer(true);
	}
	
	
	const chartPanelStyle =
	{
	    flex: 1,

	    width:
	        "100%",

	    height:
	        "100%",

	    minWidth:
	        0,

	    minHeight:
	        0,

	    boxSizing:
	        "border-box",

	    display:
	        "flex",

	    flexDirection:
	        "column",

	    padding:
	        "14px 16px",

	    //--------------------------------------------------------
	    // Soft grey analytical surface
	    //--------------------------------------------------------
	    background:
	        "linear-gradient(145deg, #ffffff 0%, #f3f5f6 100%)",

	    //--------------------------------------------------------
	    // Fine edge
	    //--------------------------------------------------------
	    border:
	        "1px solid rgba(205,212,218,0.72)",

	    //--------------------------------------------------------
	    // Square by default
	    //--------------------------------------------------------
	    borderRadius:
	        "0px",

	    //--------------------------------------------------------
	    // Defined tile shadow
	    //--------------------------------------------------------
	    boxShadow:
	        "0 10px 22px rgba(20,35,50,0.18)",

	    overflow:
	        "hidden"
	};
	
	
	const topLeftTileStyle =
	{
	    borderTopLeftRadius:
	        "8px"
	};


	const topRightTileStyle =
	{
	    borderTopRightRadius:
	        "8px"
	};


	const bottomLeftTileStyle =
	{
	    borderBottomLeftRadius:
	        "8px"
	};


	const bottomRightTileStyle =
	{
	    borderBottomRightRadius:
	        "8px"
	};


  // ---------------- RENDER ----------------

  return (
    <div style={thisContainer}>
	

        <Header showSurveySelector = {false} transitionHide={true}/>
        <LeftMenu />
		<div style={overlayStyle} />
		<div
		    style={{
		        position: "absolute",

		        top: "0px",      // below header

		        left: "38px",     // beside menu

		        right: "0",

		        bottom: "-30",
				flex:1,
				marginRight:'0px'
		    }}
		>
			<div style={DASHBOARD_TABLE_STYLE}>

			    <div style={DASHBOARD_ROW_STYLE}>

			        <div style={{...DASHBOARD_COLUMN_STYLE, padding:'5px'}}>
						<div style={contentStyle}>
							<InsightKpiStrip/>
							<ExecutiveSummaryCard

							    summary={
							        "The AI analysed 1,482 documents and identified 68 actionable insights. Four critical risks require immediate attention while overall portfolio risk has reduced by 8.4% since June."
							    }

							/>
						</div>
					</div>
				</div>
				<div style={DASHBOARD_ROW_STYLE}>
			        <div style={DASHBOARD_COLUMN_STYLE}>
						<div
						    style={{
						        gridColumn: "1",
						        gridRow: "2",
								height:'300px'
						    }}
						>
						<div
						    style={{
						        ...chartPanelStyle,
						        ...topLeftTileStyle
						    }}
						>
								<InsightsByCategory
								    id="insightsByCategory"
								    title="INSIGHTS BY CATEGORY"
								    data={insightsByCategory}
								    clickFunction={getInsightListForCategory}
								/>
							</div>	
						</div>
					</div>
					<div style={DASHBOARD_COLUMN_STYLE}>
						<div
							style={{
							        gridColumn: "1",
							        gridRow: "2",
									height:'300px'
							    }}
							>
							<div style={chartPanelStyle}>
							<InsightsOverTime

						        id="insightsOverTime"

						        title="INSIGHTS OVER TIME"


						        clickFunction={(category) =>
						        {
						            console.log(category);
						        }}

						    />
							</div>	
						</div>
					</div>
					<div style={DASHBOARD_COLUMN_STYLE}>
						<div
							style={{
							        gridColumn: "1",
							        gridRow: "2",
									height:'300px'
							    }}
							>
							<div style={chartPanelStyle}>
							<PortfolioRiskMatrix

						        id="portfolioriskmatrix"

						        title="PORTFOLIO RISK MATRIX"


						        clickFunction={(category) =>
						        {
						            console.log(category);
						        }}

						    />
							</div>	
						</div>
					</div>
					<div style={DASHBOARD_COLUMN_STYLE}>
						<div
							style={{
							        gridColumn: "1",
						        	gridRow: "2",
									height:'300px'
							    }}
							>
							<div
							    style={{
							        ...chartPanelStyle,
							        ...topRightTileStyle
							    }}
							>
							<ComplianceOverview

						        id="complianceoverview"

						        title="COMPLIANCE OVERVIEW"


						        clickFunction={(category) =>
						        {
						            console.log(category);
						        }}

						    />
							</div>	
						</div>
					</div>
				</div>
				<div style={DASHBOARD_ROW_STYLE}>
			        <div style={DASHBOARD_COLUMN_STYLE}>
						<div
						    style={{
						        gridColumn: "1",
						        gridRow: "2",
								height:'300px'
						    }}
						>
						<div
						    style={{
						        ...chartPanelStyle,
						        ...bottomLeftTileStyle
						    }}
						>
						<QualitativeImpact

						        id="quantitativeimpact"

						        title="QUALITATIVE IMPACT (PORTFOLIO)"


						        clickFunction={(category) =>
						        {
						            console.log(category);
						        }}

						    />
							</div>
						</div>
					</div>
					<div style={DASHBOARD_COLUMN_STYLE}>
						<div
						    style={{
						        gridColumn: "1",
						        gridRow: "2",
								height:'300px'
						    }}
						>
						<div style={chartPanelStyle}>
						    <CostImpactAnalysis
						        id="costImpactAnalysis"
						        clickFunction={
						            item =>
						            {
						                console.log(
						                    item);
						            }
						        }
						    />
							</div>
						</div>
					</div>
					<div style={DASHBOARD_COLUMN_STYLE}>
						<div
						    style={{
						        gridColumn: "1",
						        gridRow: "2",
								height:'300px'
						    }}
						>
						<div
						    style={{
						        ...chartPanelStyle,
						        ...bottomRightTileStyle
						    }}
						>
						<RecommendationsPipeline
						    id="recommendationsPipeline"
						    title="Recommendations Pipeline"
						/>
						</div>
						</div>
					</div>
				</div>					
			</div>
			<div style={DASHBOARD_ROW_STYLE}>
		        <div style={DASHBOARD_COLUMN_STYLE}>
					<PortfolioInspector
						onWorkspaceRequested={
					        handleWorkspaceRequested
					    }
					/>
				</div>
			</div>				
		</div>
		<WorkspaceDrawer
			visible={workspaceVisible}
			onClose={hideWorkspaceDrawer}
		/>
		<InsightsDrawer
		    display={showInsightDrawer}
		    title={selectedInsightCategory}
		    insights={insightList}

		    closeFunction={() =>
		    {
		        setShowInsightDrawer(false);
		    }}

		    clickFunction={(insight) =>
		    {
				history.push("/insight/" + insight.id);
		    }}
		/>
    </div>
  );
}

